import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import './index.css'
import App from './App.tsx'
import { initPWA } from './utils/pwa'
import { applyAppBrandingToDocument } from './extension/gaoqian/branding'

applyAppBrandingToDocument()

// 初始化 PWA
initPWA()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
